import { ColData } from 'ufinet-web-components'

export const colsApps: ColData[] = [
	{ field: 'name', header: 'COL.APP', width: '250px', nonFilterable: true, editable: true },
	{ field: 'securityName', header: 'COL.APP.SECURITY_NAME', width: '250px', nonFilterable: true, editable: true },
	{ field: 'description', header: 'COL.APP.DESCRIPTION', width: '250px', nonFilterable: true, editable: true },
]
